// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { PortalPadding } from '@med/app/home/demo/guided-tour/models/portal-padding';
import { ElementDimensions } from '@med/app/home/demo/guided-tour/models/element-dimensions';

@Injectable()
export class PortalDimensionsService {
  calculatePortalDimensions(relativeElementRect: ClientRect, extraPadding: PortalPadding): ElementDimensions {
    const defaultPadding = 5;
    const width = relativeElementRect.width + (2 * defaultPadding) + this.toNumber(extraPadding?.right) + this.toNumber(extraPadding?.left);
    const height = relativeElementRect.height + (2 * defaultPadding) + this.toNumber(extraPadding?.bottom) + this.toNumber(extraPadding?.top);
    const top = relativeElementRect.top - defaultPadding - this.toNumber(extraPadding?.top);
    const left = relativeElementRect.left - defaultPadding - this.toNumber(extraPadding?.left);

    return {top, left, width, height};
  }

  private toNumber(value: any): number {
    if (!value) {
      return 0;
    }

    return value;
  }
}
